import axios from 'axios'

export const API_ORIGIN = import.meta.env.DEV
  ? 'https://caiwuningbo.divcloud.cn'
  : ''

axios.defaults.baseURL = API_ORIGIN

export default axios
